// third
import { FirebaseOptions } from "@angular/fire/app";

// fromt project
import
{
    ProductionEnvironmentName,
    DevelopmentEnvironmentName,
    LocalEnvironmentName
} from './environment-consts';



export const environment: EnviromentData = {
    API_URL: 'https://picacoin-01-dev.onrender.com',
    CDN_URL: 'https://t2pp-adds-ws-fe-01-cdn-01-development-01.s3.sa-east-1.amazonaws.com',
    APP_VERSION: "1.0.45",

    ENVIRONMENT_NAME: DevelopmentEnvironmentName,
    VAPID_PUBLIC_KEY: "*****************************************",
};

export interface EnviromentData {
    API_URL: string,
    CDN_URL: string,
    APP_VERSION: string,

    ENVIRONMENT_NAME: string,

    VAPID_PUBLIC_KEY: string,
}

export class AppEnvironmentHandler {
    static GetEnviromentCollectionPrefix = () => {
        let value = '';

        value += environment.ENVIRONMENT_NAME + '-';

        return value;
    }

    static IsProd = () => {
        let value = false;

        value = environment.ENVIRONMENT_NAME == ProductionEnvironmentName

        return value;
    }

    static IsLocal = () => {
        let value = false;

        value = environment.ENVIRONMENT_NAME == LocalEnvironmentName

        return value;
    }

    static DoIfProduction = (callback: () => void) => {
        if (AppEnvironmentHandler.IsProd())
            callback();
    }

    static DoIfLocal = (callback: () => void) => {
        if (AppEnvironmentHandler.IsLocal())
            callback();
    }
}
